import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ToastComponent } from './toast.component';

@NgModule({
    declarations: [
        ToastComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule
    ],
    exports: [
        ToastComponent,
    ]
})
export class ToastModule { }
